export const LINK_TO_HINT = 'Изменить номер телефона';
export const FATAL_ERROR_DESCRIPTION = 'Неправильный код подтверждения, попробуйте заново';
